import { render, staticRenderFns } from "./custom-radio-img.vue?vue&type=template&id=62d49ea0&scoped=true&"
import script from "./custom-radio-img.vue?vue&type=script&lang=js&"
export * from "./custom-radio-img.vue?vue&type=script&lang=js&"
import style0 from "./custom-radio-img.vue?vue&type=style&index=0&id=62d49ea0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d49ea0",
  null
  
)

export default component.exports